var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M32.72 17H12.28A1.28 1.28 0 0011 18.28v15.44c0 .707.573 1.28 1.28 1.28h20.44A1.28 1.28 0 0034 33.72V18.28A1.28 1.28 0 0032.72 17zM36 31h.72a1.28 1.28 0 001.273-1.15l.007-.13V14.28a1.28 1.28 0 00-1.15-1.273L36.72 13H16.28a1.28 1.28 0 00-1.273 1.15l-.007.13V15h17.72A3.28 3.28 0 0136 18.28V31zm0 2.72A3.28 3.28 0 0132.72 37H12.28A3.28 3.28 0 019 33.72V18.28A3.28 3.28 0 0112.28 15H13v-.72a3.28 3.28 0 013.094-3.275L16.28 11h20.44a3.28 3.28 0 013.275 3.094l.005.186v15.44a3.28 3.28 0 01-3.094 3.275L36.72 33H36z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M15 29a1 1 0 110 2 1 1 0 010-2zm15 0v2H17v-2h13zm-15-4a1 1 0 110 2 1 1 0 010-2zm15 0v2H17v-2h13zm-15-4a1 1 0 110 2 1 1 0 010-2zm15 0v2H17v-2h13z" }))));
});
